import React from "react";
import { Lock } from "lucide-react";
import { PARAMS, WAVEFORMS } from "../../lib/synthLab";
import { cn } from "../../lib/utils";

export const WaveformPicker = ({ value, onChange, disabled }) => (
  <div className="grid grid-cols-4 gap-1.5">
    {WAVEFORMS.map((w) => (
      <button
        key={w.value}
        type="button"
        disabled={disabled}
        onClick={() => onChange(w.value)}
        title={w.blurb}
        className={cn(
          "rounded-md border px-2 py-1.5 text-xs font-medium transition-colors",
          value === w.value
            ? "border-primary bg-primary text-primary-foreground"
            : "border-input bg-background hover:bg-accent hover:text-accent-foreground",
          disabled && "opacity-50"
        )}
      >
        {w.label}
      </button>
    ))}
  </div>
);

// A single knob rendered as a labeled range slider, with an optional locked
// state.
export const Knob = ({ param, value, onChange, disabled }) => (
  <div className={cn("rounded-lg border border-border bg-card/60 p-3", disabled && "opacity-60")}>
    <div className="flex items-baseline justify-between">
      <label htmlFor={`knob-${param.id}`} className="text-sm font-medium" title={param.blurb}>
        {param.label}
        {disabled && <Lock className="ml-1 inline h-3 w-3 text-muted-foreground" />}
      </label>
      <span className="font-mono text-xs text-muted-foreground">{param.format(value)}</span>
    </div>
    <input
      id={`knob-${param.id}`}
      type="range"
      min={param.min}
      max={param.max}
      step={param.step}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(param.id, parseFloat(e.target.value))}
      className="mt-2 h-2 w-full cursor-pointer appearance-none rounded-full bg-secondary accent-primary disabled:cursor-not-allowed"
    />
  </div>
);

// The shared parameter rack. `lockedExcept` (an id) locks every knob but one.
const SynthRack = ({ patch, onParam, lockedExcept, hideWaveform }) => (
  <div className="grid gap-3 sm:grid-cols-2">
    {!hideWaveform && (
      <div className="rounded-lg border border-border bg-card/60 p-3 sm:col-span-2">
        <div className="mb-2 text-sm font-medium">Waveform</div>
        <WaveformPicker
          value={patch.waveform}
          onChange={(v) => onParam("waveform", v)}
          disabled={lockedExcept != null && lockedExcept !== "waveform"}
        />
      </div>
    )}
    {PARAMS.map((p) => (
      <Knob
        key={p.id}
        param={p}
        value={patch[p.id]}
        onChange={onParam}
        disabled={lockedExcept != null && lockedExcept !== p.id}
      />
    ))}
  </div>
);

export default SynthRack;
